import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { callParkStockEndpoint } from "../api";
import { CaravanStockDTO } from "../types";

export const useGetParkStockData = () => {
  const { park } = useParams();

  const parkString = park ?? "";

  return useQuery<CaravanStockDTO[], Error>({
    queryKey: ["park-stock", parkString],
    queryFn: () => callParkStockEndpoint(parkString),
  });
};
